import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "~/lib/utils";

interface Props {
  className?: string;
}

export const Spinner = ({ className }: Props) => {
  return (
    <Loader2 className={cn("text-primary h-8 w-8 animate-spin", className)} />
  );
};

interface CenterSpinnerProps {
  withText?: boolean;
}

export const CenterSpinner = ({ withText = false }: CenterSpinnerProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-1 items-center justify-center">
      <div className="flex flex-col items-center gap-2">
        <Spinner />
        {withText && (
          <p className="text-muted-foreground text-sm">
            {t("commons.loading...")}
          </p>
        )}
      </div>
    </div>
  );
};

export const OverlaySpinner = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-background/80 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-xs">
      <div className="flex flex-col items-center gap-2">
        <Spinner />
        <p className="text-muted-foreground text-sm">
          {t("commons.loading...")}
        </p>
      </div>
    </div>
  );
};
